import React, { useEffect } from "react";
import "../../../../../Assets/Styles/UserGuide.scss";

const HR_MSS_AdminGuide = (props) => {
  useEffect(() => {
    // document.getElementById("saved-only").classList.add("guide-is-open");
    // document.getElementById("bookmarked-items-guide").scrollIntoView();
    // return () => {
    //   document.getElementById("saved-only").classList.remove("guide-is-open");
    // };
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const toggleNextGuide = () => {
    props.ToggleNextDialog();
  };

  return (
    <div
      className="guide-dialog jpa-items-guide MSS-grid-guide"
      id="jpa-items-guide"
    >
      <i className="feather-x" onClick={() => props.CloseGuide()}></i>
      <p className="dialog-text">
        {translateText("MSS_walkthrough_1")}
        {translateText("MSS_walkthrough_2")}
        {translateText("MSS_walkthrough_3")}
        {translateText("MSS_walkthrough_4")}
      </p>
      <section className="dialog-footer">
        <div
          className="steps-navs back"
          style={{ opacity: "0", pointerEvents: "none" }}
          onClick={null}
        >
          <i className="feather-arrow-left"></i>
          <p>{translateText("back")}</p>
        </div>
        <div className="indicators">
          {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((Index) => (
            <span
              onClick={() => props.JumpToStep(Index)}
              className={
                Index === 0 ? "step-circle active-circle" : "step-circle"
              }
            ></span>
          ))}
        </div>
        <div className="steps-navs next" onClick={() => toggleNextGuide()}>
          <p>{translateText("next")}</p>
          <i className="feather-arrow-right"></i>
        </div>
      </section>
    </div>
  );
};

export default HR_MSS_AdminGuide;
